/*
https://www.facebook.com/
https://www.instagram.com/?hl=en
https://twitter.com/?lang=en

* Copyright (c) 2021. by N-Ach (Pvt) Ltd
*
* ╔═╗ ╔╗    ╔═══╗  ╔╗
* ║║╚╗║║    ║╔═╗║  ║║
* ║╔╗╚╝║    ║║ ║╠══╣╚═╗
* ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
* ║║ ║║║╚══╝║╔═╗║╚═╣║║║
* ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
*
* All rights reserved.
*
* This software is the confidential and proprietary information
* of N-Ach (Pvt) Ltd. ("Confidential Information"). You
* shall not disclose such Confidential Information and shall use
* it only in accordance with the terms of the license agreement
* you entered into with N-Ach (Pvt) Ltd.
*
*
* @Author Shalani Chethana
* @Date 22/01/2025
*/


import React from "react";
import "./home.css";
import banner from "../../assets/images/Homepage2.png";
import IconButton from '@mui/material/IconButton';
import { Facebook, WhatsApp, LinkedIn } from '@mui/icons-material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import CallIcon from '@mui/icons-material/Call';
import Stack from '@mui/material/Stack';

export default function BannerHome() {
  return (
    <div>
      <div className="home-styled-container">
        <div className="home-styled-back"></div>
        <div className="home-styled-content" >

          <div className="home-background-circle"></div>
          <img src={banner} className="home-background-phone" alt="banner" />

          <div className="home-main-content" >
            <div className="home-content-container" >
              <div className="home-text-container">
                <h3 className="home-title">
                  Let’s Innovate<br />
                  Something Great<br />
                  Together...
                </h3>
                <p className="home-discription">
                  We are more than just a software company—we are your strategic partner in business growth. Our cutting-edge software solutions empower companies of all sizes and industries to scale, innovate, and thrive in the digital era.
                </p>

                <div className="home-PayStoreBtn">
                  <Stack direction="row" spacing={1}>
                    <IconButton
                      aria-label="email"
                      href="mailto:info@n-ach.com">
                      <MailOutlineIcon color="#ffff" sx={{ color: "white", fontSize: 22 }} />
                    </IconButton>
                    <IconButton
                      aria-label="call"
                      href="tel:+9715898322886">
                      <CallIcon color="#ffff" sx={{ color: "white", fontSize: 22 }} />
                    </IconButton>
                    <IconButton
                      aria-label="Whatsapp"
                      href="tel:+9715898322886">
                      <WhatsApp color="#ffff" sx={{ color: "white", fontSize: 22 }} />
                    </IconButton>
                    <IconButton
                      aria-label="facebook"
                      href="https://www.facebook.com/N.ACH.SOFTWARE.SOLUTIONS?mibextid=ZbWKwL"
                      target="_blank"
                      rel="noopener noreferrer">
                      <Facebook color="#ffff" sx={{ color: "white", fontSize: 22 }} />
                    </IconButton>
                    <IconButton
                      aria-label="linkedin"
                      href="https://www.linkedin.com/company/n-ach/"
                      target="_blank"
                      rel="noopener noreferrer">
                      <LinkedIn color="#ffff" sx={{ color: "white", fontSize: 22 }} />
                    </IconButton>
                  </Stack>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


